import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import React from 'react';
import { FormattedMessage, defineMessages } from 'react-intl';
import SocialButton from './SocialButton';
import 'styles/share-kit.scss';
import 'styles/icons.scss';
import 'styles/buttons.scss';
const messages = defineMessages({
    share: 'Share on',
});
export default class ShareKit extends React.Component {
    render() {
        return (_jsxs("ul", { className: classnames(this.props.className, 'share-kit'), children: [_jsx("li", { children: _jsxs(SocialButton, { className: "button share-kit__entry share-kit__entry--facebook", service: "facebook", link: this.props.link, children: [_jsx(FormattedMessage, Object.assign({}, messages.share)), " ", _jsx("i", { className: "icon-fb-inverted" })] }) }), _jsx("li", { children: _jsx(SocialButton, { className: "button share-kit__entry share-kit__entry--twitter", service: "twitter", link: this.props.link, children: _jsx("i", { className: "icon-tw-inverted" }) }) })] }));
    }
}
